export const CLASSPREFIX = 'muze';
export const STACK = 'stack';
export const GROUP = 'group';
export const IDENTITY = 'identity';
export const ANGLE = 'angle';
export const RADIUS = 'radius';
export const SIZE = 'size';
export const COLOR = 'color';
export const SHAPE = 'shape';
export const TEXT = 'text';
export const OUTER_RADIUS_VALUE = 'outerRadiusValue';
export const TEXT_ANCHOR_MIDDLE = 'middle';
export const ENCODING = {
    X: 'x',
    Y: 'y',
    X0: 'x0',
    Y0: 'y0',
    RADIUS: 'radius',
    RADIUS0: 'radius0',
    ANGLE: 'angle',
    ANGLE0: 'angle0',
    COLOR: 'color',
    SHAPE: 'shape',
    SIZE: 'size',
    TEXT: 'text'
};

export const STROKE_DASHARRAY = 'stroke-dasharray';

export const ASCENDING = 'asc';

export const AGG_FN_SUM = 'sum';

export const AREA_LAYER = 'area';
export const ARC_LAYER = 'arc';
export const LINE_LAYER = 'line';
export const TEXT_LAYER = 'text';
export const POINT_LAYER = 'point';
export const BAR_LAYER = 'bar';
export const TICK_LAYER = 'tick';
export const SIMPLE_LAYER = 'simple';
export const BASE_LAYER = 'base';
